import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShare = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	height: 48,
	width: 48,
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", {}),
		/* @__PURE__ */ _jsx("title", { children: "share" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5.25,
			cy: 11.25,
			r: 3.75,
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "1.5px"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 18.75,
			cy: 6,
			r: 3.75,
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "1.5px"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 18.75,
			cy: 18,
			r: 3.75,
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "1.5px"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 8.746,
			y1: 9.891,
			x2: 15.254,
			y2: 7.36,
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "1.5px"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 8.605,
			y1: 12.928,
			x2: 15.395,
			y2: 16.323,
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "1.5px"
		})
	]
});
export { SvgShare as ReactComponent };
